const getLabelByValue = (value: string, allData: any ): string | undefined => {
   
    try {
    const datas = allData.find(type => type.value === value);
 
    
    return datas?.label || 'Unknown';
    }
    catch(e){
    
        
        return 'Incorrect'
    }
};

export default getLabelByValue;